import React, { useState, useEffect, useCallback } from "react";
import "../../styles/desktop/main.css";
import CampoImagem from "../CampoImagem/campoimagem";
import Menu from "../menu/menu";
import TextMain from "../Texto Principal/textoMain";
import Agendamentos from "../Agendamento/agendamento"; // Importe o componente Agendamentos
import Loader from "../loader/loader";
import Exaustor from "../Exaustores/exaustores"; 
import AlarmeModal from "../Alarme/AlarmeModal";
import Eventos from "../events/eventos";
import background from "../../assets/img/background.png";

import pagina1 from "../../assets/img/Pagina01.png"; 
import pagina2 from "../../assets/img/Pagina02.png"; 
import ChatBot from "../Plus/ChatBot/chatbot";
import PLUS from "../Plus/plus";
import Dispositivos from "../Plus/Dispositivos/dispositivo"
import Gestao from "../Gestao/gestao";


import Grupo01 from "../Campo Luzes/Grupo01";
import Grupo02 from "../Campo Luzes/Grupo02";

const Main = () => {
  const [paginaAtual, setPaginaAtual] = useState("Térreo");
  const [loading, setLoading] = useState(true);
  const [loadingImage, setLoadingImage] = useState(false);
  const [imagemCentral, setImagemCentral] = useState(pagina1);

  console.log(imagemCentral);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 800);

    return () => clearTimeout(timer); // Limpe o timer se o componente for desmontado
  }, []);

  const loaderImage = useCallback(() => {
    setPaginaAtual(pagina1);
    setLoadingImage(true);
    setTimeout(() => {
      setLoadingImage(false);
    }, 1000);
  }, []);

  const trocarPagina = useCallback((pagina) => {
    console.log(`Trocando para a página: ${pagina}`);
    setPaginaAtual(pagina);
    if (pagina === "Agendamentos") {
      setImagemCentral(""); 
    }
    if(pagina === "Exaustor") {
      setImagemCentral(pagina1);
    }
    if(pagina === "Alarme") {
      setImagemCentral(pagina1);
    }
  }, []);

  const trocarImagem = useCallback((img) => {
    if (imagemCentral !== img) {
      console.log("Imagem trocada para:", img);
      loaderImage();
      setImagemCentral(img);
    }
  }, [imagemCentral, loaderImage]);

  const groupComponents = {
    [pagina1]: <Grupo01 />,
    [pagina2]: <Grupo02 />,
  };

  const renderGroup = () => {
    return groupComponents[imagemCentral] || null;
  };

  return (
    <div id="divMain">
      {loading ? <Loader /> : null}
      <Menu
        trocarPagina={trocarPagina}
        trocarImagem={trocarImagem}
        paginaAtual={paginaAtual}
        paginas={[pagina1, pagina2]}
      />
      <div id="content" style={{ backgroundImage: `url(${background})` }}>
        <TextMain />
        {paginaAtual === "Gestao" ? (
          <Gestao />
        ) : (
          <div id="content-Central">
            {paginaAtual === "Agendamentos" ? (
              <Agendamentos />
            ) : paginaAtual === "Exaustor" ? (
              <Exaustor />
            ) : paginaAtual === "Chatbot" ? (
              <ChatBot />
            ) : paginaAtual === "history" ? (
              <Eventos />
            ) : paginaAtual === "PLUS" ? (
              <PLUS />
            ) : paginaAtual === "Dispositivos" ? (
              <Dispositivos />
            ) : paginaAtual === "Alarme" ? (
              <AlarmeModal />
            ) :  (
              <>
                {imagemCentral && <CampoImagem imagem={imagemCentral} loadingImage={loadingImage} />}
                {renderGroup()}
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Main;